//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date : 04/09/2024
// Version : 1
// Description : para editar tanques
//------Changes -------------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import { UrlApi } from "../../services/apirest";
import {
  Container,
  Grid,
  Box,
  TextField,
  Button,
  IconButton,
  Stack,
  Autocomplete,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import Notify from "../Notify";
import Alerta from "../Alerta";
import { logEventos } from "../../services/services";
import moment from "moment/moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function EditarTanque(props) {
  const [datosTanque, setDatosTanque] = useState(props.datos); // viene del motivos_salida {editar}
  const [disBtn, setDisBtn] = useState(false);
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
  const [mensajeAlerta, setMensajeAlerta] = useState(""); //mensaje que contendrá el componente "alerta"
  const [finalizar, setFinalizar] = useState(); //finalizar === 1 lo manda como prop el componente "notify" e indica que la transaccion ha finalizado y debe ejecutarse la funcion para cerrar
  const [severityAlerta, setSeverityAlerta] = useState(""); //define severidad de la alerta (success error o warning)
  const [severitySnack, setSeveritySnack] = useState(""); //define severidad del snackbar (notificación)
  const [editar, setEditar] = useState(props.editar); //Estado q mostrará o no el form de edicion de choferes
  const [disabledGuardar, setDisabledGuardar] = useState(false);

  useEffect(() => {
    setDatosTanque({
      ...props.datos,
    });
  }, [props.datos]);

  const handleClose = () => {
    setEditar(!editar);
    if (props.onClose) {
      props.onClose();
    }
  };

  const [fabricante, setFabricante] = useState([]);
  const [fabricanteSeleccionado, setFabricanteSeleccionado] = useState("");

  //funcion para obtener sucursal del usuario logueado
  const obtenerFabricante = () => {
    fetch(UrlApi + "/fabricantes")
      .then((data) => data.json())
      .then((data) => setFabricante(data));
  };

  useEffect(() => {
    obtenerFabricante();
  }, []);

  useEffect(() => {
    if (fabricante.length > 0 && datosTanque?.fabricante) {
      const fabElegido = fabricante.find(
        (p) => p.id === datosTanque.fabricante
      );
      setFabricanteSeleccionado(fabElegido || null);
    }
  }, [fabricante, datosTanque]);

  const [tipoVTV, setTipoVTV] = useState([]);

  const obtenerTipoVTV = () => {
    fetch(UrlApi + "/desplegables/vencimientos_carga_tanques_vtv")
      .then((data) => data.json())
      .then((data) => setTipoVTV(data));
  };
  useEffect(() => {
    obtenerTipoVTV();
  }, []);

  const [tipoSeguro, setTipoSeguro] = useState([]);

  const obtenerTipoSeguro = () => {
    fetch(UrlApi + "/desplegables/vencimientos_carga_tanques_seguro")
      .then((data) => data.json())
      .then((data) => setTipoSeguro(data));
  };
  useEffect(() => {
    obtenerTipoSeguro();
  }, []);

  //------------- CALCULO DE FECHAS PROXIMAS --------------------//
  useEffect(() => {
    // ULTIMA REVISION QUINQUENAL 5 AÑOS
    const fechaUltima = moment(datosTanque.fecha_ultima);
    const fechaProxUltima = fechaUltima.add(5, "years").format("YYYY-MM-DD");

    // VALVULA DE SEGURIDAD 2 AÑOS
    const fechaRevValSeg = moment(datosTanque.fecha_rev_val_seg);
    const fechaProxRevValSeg = fechaRevValSeg
      .add(2, "years")
      .format("YYYY-MM-DD");

    // VALVULA DE EXCESO 1 AÑO
    const fechaRevValExc = moment(datosTanque.fecha_rev_val_exc);
    const fechaProxRevValExc = fechaRevValExc
      .add(1, "years")
      .format("YYYY-MM-DD");

    // REVISION DE MANGUERA 6 MESES
    const fechaRevMan = moment(datosTanque.fecha_rev_man);
    const fechaProxRevMan = fechaRevMan.add(6, "months").format("YYYY-MM-DD");

    // REVISION DE VTV
    const fechaVTV = moment(datosTanque.fecha_vtv);
    let fechaProxVTV = null;
    if (datosTanque.tipo_ven_vtv == 331) {
      //anual
      fechaProxVTV = fechaVTV.add(1, "years").format("YYYY-MM-DD");
    } else if (datosTanque.tipo_ven_vtv == 332) {
      //semestral
      fechaProxVTV = fechaVTV.add(6, "months").format("YYYY-MM-DD");
    } else if (datosTanque.tipo_ven_vtv == 333) {
      // c/4 meses
      fechaProxVTV = fechaVTV.add(4, "months").format("YYYY-MM-DD");
    } else {
      fechaProxVTV = null;
    }
    // MATAFUEGOS 1 AÑO
    const fechaMatafuego = moment(datosTanque.fecha_oblea_matafuegos);
    const fechaproxMatafuego = fechaMatafuego
      .add(1, "years")
      .format("YYYY-MM-DD");

    // REVISION DE SEGURO
    const fechaSeguro = moment(datosTanque.fecha_seguro);
    let fechaProxSeguro = null;
    if (datosTanque.tipo_ven_seguro == 334) {
      //mensual
      fechaProxSeguro = fechaSeguro.add(1, "months").format("YYYY-MM-DD");
    } else if (datosTanque.tipo_ven_seguro == 335) {
      //semestral
      fechaProxSeguro = fechaSeguro.add(6, "months").format("YYYY-MM-DD");
    } else if (datosTanque.tipo_ven_seguro == 336) {
      //anual
      fechaProxSeguro = fechaSeguro.add(1, "years").format("YYYY-MM-DD");
    } else {
      fechaProxSeguro = null;
    }

    setDatosTanque((prevDatos) => ({
      ...prevDatos,
      prox_ultima: fechaProxUltima,
      prox_rev_val_seg: fechaProxRevValSeg,
      prox_rev_val_exc: fechaProxRevValExc,
      prox_rev_man: fechaProxRevMan,
      prox_vtv: fechaProxVTV,
      prox_oblea_matafuegos: fechaproxMatafuego,
      prox_seguro: fechaProxSeguro,
    }));
  }, [
    datosTanque.fecha_ultima,
    datosTanque.fecha_rev_val_seg,
    datosTanque.fecha_rev_val_exc,
    datosTanque.fecha_rev_man,
    datosTanque.fecha_vtv,
    datosTanque.fecha_oblea_matafuegos,
    datosTanque.fecha_seguro,
    datosTanque.tipo_ven_vtv,
    datosTanque.tipo_ven_seguro,
  ]);

  //Funcion para guardar
  const guardarEditar = async (e) => {
    logEventos(
      "Guardar editar Tanques Moviles",
      "Tanques Moviles",
      "Se guardo la edición",
      localStorage.getItem("user")
    );
    setDisabledGuardar(true);
    e.preventDefault();
    const response = await fetch(
      UrlApi + "/tanque_rehabilitacion/" + datosTanque.id_tanque,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          matricula: datosTanque.matricula,
          capacidad: datosTanque.capacidad,
          producto: datosTanque.producto,
          num_tanque: datosTanque.num_tanque,
          num_auditoria: datosTanque.num_auditoria,
          fabricante: fabricanteSeleccionado.id,
          patente: datosTanque.patente,
          volumen: datosTanque.volumen,
          datos: datosTanque.datos,
          fecha_ultima: datosTanque.fecha_ultima,
          fecha_rev_val_seg: datosTanque.fecha_rev_val_seg,
          fecha_rev_val_exc: datosTanque.fecha_rev_val_exc,
          fecha_rev_man: datosTanque.fecha_rev_man,
          fecha_vtv: datosTanque.fecha_vtv,
          fecha_oblea_matafuegos: datosTanque.fecha_oblea_matafuegos,
          fecha_seguro: datosTanque.fecha_seguro,
          prox_ultima: datosTanque.prox_ultima,
          prox_rev_val_seg: datosTanque.prox_rev_val_seg,
          prox_rev_val_exc: datosTanque.prox_rev_val_exc,
          prox_rev_man: datosTanque.prox_rev_man,
          prox_vtv: datosTanque.prox_vtv,
          prox_oblea_matafuegos: datosTanque.prox_oblea_matafuegos,
          prox_seguro: datosTanque.prox_seguro,
          tipo_ven_vtv: datosTanque.tipo_ven_vtv,
          tipo_ven_seguro: datosTanque.tipo_ven_seguro,
          usuario: localStorage.getItem("user"),
        }),
      }
    );
    if (response.ok === false) {
      console.log("ERROR EN API");
      const error = response && response.json();
      setError(error);
      setSeverityAlerta("error");
      setMensajeAlerta("Inconvenientes con la API. No se pudo guardar. ");
    } else {
      console.log("Conexión con api OK");
      try {
        //Parseo respuesta de la api a json()
        const json = await response.json();
        //si api me devuelve lo q le puse en message
        if (json.message) {
          //Si ese mensaje es "OK"
          if (json.message === "OK") {
            console.log("Guardado Satisfactoriamente");
            setNotificacion(true);
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setMensaje("Guardado");
            setSeveritySnack("success");
          } else {
            console.log("res en api incorrecto. Revisar que sea 'OK'");
            setNotificacion(true);
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setSeveritySnack("error");
            setMensaje("Registro Guardado. REVISAR RESPUESTA DE API (E_S)");
          }
        } else if (json.sqlMessage) {
          json && setError(json);
          console.log(json);
          setMensajeAlerta(
            "SQL erróneo (" + json.code + " Errno: " + json.errno + " )"
          );
        } else {
          setMensajeAlerta("ERROR DESCONOCIDO.");
        }
      } catch (error) {
        if (error.toString().includes("is not valid JSON")) {
          console.log(
            "Guardado. Advertencia: Actualizar respuesta de api. JSON invalido."
          );
          setNotificacion(true);
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("Guardado");
          setSeveritySnack("success");
        } else {
          setMensajeAlerta("ERROR DESCONOCIDO.");
        }
      }
    }
    handleClose();
  };
  //funcion para almacenar
  const almacenar = (e) => {
    setDatosTanque({
      ...datosTanque,
      [e.target.name]: e.target.value === "" ? null : e.target.value,
    });
  };
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };
  const size = "small";

  // para el helpertext cuando pasan de los 100 -en volumen
  const [error2, setError2] = useState(false);
  const handleChange = (e) => {
    const value = e.target.value;
    const numero = Number(value);

    if (value === "") {
      setError2(false);
      almacenar(e);
    } else if (/^[0-9]*$/.test(value)) {
      if (numero <= 100) {
        setError2(false);
        almacenar(e);
      } else {
        setError2(true);
      }
    }
  };

  //  console.log("PROX VTV", datosTanque.prox_vtv);
  //  console.log("PROX OBLEA", datosTanque.prox_oblea_matafuegos);
  //  console.log("prox seguro", datosTanque.prox_seguro);

  return (
    <div>
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container backgroundColor="#1F618D" p={1.5}>
            <Grid item xs={2}>
              <IconButton onClick={handleClose}>
                <ArrowBackIcon sx={{ color: grey[50] }} />
              </IconButton>
            </Grid>

            <Grid
              item
              xs={8}
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="h5" color="#ffffff">
                Editar tanque
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <form onSubmit={guardarEditar} autoComplete="off">
          <Grid container spacing={2}>
            {/* Datos del Tanque */}
            <Grid item xs={12}>
              <Box
                border={0.5}
                borderColor={grey[300]}
                backgroundColor="#F4F6F6"
                borderRadius={3}
                p={2}
                mt={1}
              >
                <Grid container spacing={2}>
                  {/* Matrícula */}
                  <Grid item xs={2}>
                    <TextField
                      fullWidth
                      size={size}
                      placeholder="0000"
                      style={style}
                      color="primary"
                      name="matricula"
                      label="Matrícula"
                      variant="outlined"
                      value={datosTanque.matricula}
                      InputProps={{
                        readOnly: true,
                      }}
                      onChange={almacenar}
                    />
                  </Grid>

                  {/* Capacidad */}
                  <Grid item xs={2}>
                    <TextField
                      fullWidth
                      size={size}
                      placeholder="0000"
                      style={style}
                      color="primary"
                      name="capacidad"
                      label="Capacidad"
                      variant="outlined"
                      value={datosTanque.capacidad}
                      InputProps={{
                        readOnly: true,
                      }}
                      onChange={almacenar}
                    />
                  </Grid>

                  {/* Producto */}
                  <Grid item xs={2}>
                    <TextField
                      fullWidth
                      size={size}
                      placeholder="00"
                      style={style}
                      color="primary"
                      name="producto"
                      label="Producto"
                      variant="outlined"
                      value={datosTanque.producto}
                      InputProps={{
                        readOnly: true,
                      }}
                      onChange={almacenar}
                    />
                  </Grid>

                  {/* N° Tanque */}
                  <Grid item xs={2}>
                    <TextField
                      fullWidth
                      size={size}
                      placeholder="-----"
                      style={style}
                      color="primary"
                      name="num_tanque"
                      label="N° Tanque"
                      variant="outlined"
                      value={datosTanque.num_tanque}
                      InputProps={{
                        readOnly: true,
                      }}
                      onChange={almacenar}
                    />
                  </Grid>

                  {/* N° Auditoría */}
                  <Grid item xs={2}>
                    <TextField
                      fullWidth
                      size={size}
                      placeholder="....."
                      style={style}
                      focused
                      color="primary"
                      required
                      name="num_auditoria"
                      label="N° Auditoría"
                      variant="outlined"
                      value={datosTanque.num_auditoria}
                      inputProps={{ maxLength: 45 }}
                      onChange={almacenar}
                    />
                  </Grid>

                  {/* Patente */}
                  <Grid item xs={2}>
                    <TextField
                      fullWidth
                      size={size}
                      placeholder="....."
                      style={style}
                      focused
                      color="primary"
                      required
                      name="patente"
                      label="Patente"
                      variant="outlined"
                      value={datosTanque.patente}
                      inputProps={{ maxLength: 45 }}
                      onChange={almacenar}
                    />
                  </Grid>

                  {/* Volumen */}
                  <Grid item xs={1.4}>
                    <TextField
                      fullWidth
                      size={size}
                      placeholder="....."
                      style={style}
                      focused
                      color="primary"
                      required
                      name="volumen"
                      label="Vol. (m3)"
                      variant="outlined"
                      value={datosTanque.volumen}
                      error={error2}
                      helperText={
                        error2 ? "El volumen no puede ser mayor a 100" : ""
                      }
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) event.preventDefault();
                      }}
                      inputProps={{ maxLength: 3 }}
                      onChange={handleChange}
                    />
                  </Grid>

                  {/* Fabricante */}
                  <Grid item xs={3.5}>
                    <Autocomplete
                      disableClearable
                      size="small"
                      required
                      noOptionsText={"Fabricante INEXISTENTE"}
                      options={fabricante}
                      style={style}
                      autoHighlight
                      getOptionLabel={(fab) => fab.nombre}
                      onChange={(event, value) =>
                        setFabricanteSeleccionado(value)
                      }
                      value={fabricanteSeleccionado} // <-- esto es importante
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          key={option.id}
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          {option.id}- {option.nombre}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          inputProps={{
                            ...params.inputProps,
                          }}
                          focused
                          size="small"
                          placeholder="Tipee para buscar..."
                          label="Fabricante"
                        />
                      )}
                    />
                  </Grid>

                  {/* Datos */}
                  <Grid item xs={4.5}>
                    <TextField
                      fullWidth
                      size={size}
                      placeholder="....."
                      style={style}
                      focused
                      color="primary"
                      required
                      name="datos"
                      label="Datos"
                      variant="outlined"
                      value={datosTanque.datos}
                      inputProps={{ maxLength: 45 }}
                      onChange={almacenar}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            {/* Fechas y Vencimientos */}
            <Grid item xs={12}>
              <Box
                border={0.5}
                borderColor={grey[300]}
                backgroundColor="#F4F6F6"
                borderRadius={3}
                p={2}
              >
                <Grid container spacing={2}>
                  {/* Revision quinquenal*/}
                  <Grid item xs={12} sm={6} md={3}>
                    <Box
                      border={1}
                      borderColor="grey.400"
                      backgroundColor="#F4F6F6"
                      borderRadius={2}
                      p={2}
                    >
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        gutterBottom
                      >
                        Revisión quinquenal
                      </Typography>
                      <TextField
                        style={style}
                        label="Última revisión"
                        name="fecha_ultima"
                        size="small"
                        type="date"
                        focused
                        required
                        fullWidth
                        value={moment(datosTanque.fecha_ultima).format(
                          "YYYY-MM-DD"
                        )}
                        onChange={almacenar}
                      />
                    </Box>
                  </Grid>
                  {/* valvula de seguridad */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Box
                      border={1}
                      borderColor="grey.400"
                      backgroundColor="#F4F6F6"
                      borderRadius={2}
                      p={2}
                    >
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        gutterBottom
                      >
                        Revisión válvulas de seguridad
                      </Typography>
                      <TextField
                        style={style}
                        label="Última revisión"
                        name="fecha_rev_val_seg"
                        size="small"
                        type="date"
                        focused
                        required
                        fullWidth
                        value={moment(datosTanque.fecha_rev_val_seg).format(
                          "YYYY-MM-DD"
                        )}
                        onChange={almacenar}
                      />
                    </Box>
                  </Grid>
                  {/* valvulas de exceso */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Box
                      border={1}
                      borderColor="grey.400"
                      backgroundColor="#F4F6F6"
                      borderRadius={2}
                      p={2}
                    >
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        gutterBottom
                      >
                        Revisión válvulas de exceso
                      </Typography>
                      <TextField
                        style={style}
                        label="Última revisión"
                        name="fecha_rev_val_exc"
                        size="small"
                        type="date"
                        focused
                        required
                        fullWidth
                        value={moment(datosTanque.fecha_rev_val_exc).format(
                          "YYYY-MM-DD"
                        )}
                        onChange={almacenar}
                      />
                    </Box>
                  </Grid>
                  {/* revision mangueras */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Box
                      border={1}
                      borderColor="grey.400"
                      backgroundColor="#F4F6F6"
                      borderRadius={2}
                      p={2}
                    >
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        gutterBottom
                      >
                        Revisión mangueras
                      </Typography>

                      <TextField
                        style={style}
                        label="Última revisión"
                        name="fecha_rev_man"
                        size="small"
                        type="date"
                        focused
                        required
                        fullWidth
                        value={moment(datosTanque.fecha_rev_man).format(
                          "YYYY-MM-DD"
                        )}
                        onChange={almacenar}
                      />
                    </Box>
                  </Grid>
                  {/* oblea matafuegos */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Box
                      border={1}
                      borderColor="grey.400"
                      backgroundColor="#F4F6F6"
                      borderRadius={2}
                      p={2}
                    >
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        gutterBottom
                      >
                        Oblea Matafuegos
                      </Typography>
                      <Grid container alignContent={"center"}>
                        <Grid item xs={12}>
                          <TextField
                            style={style}
                            label="Vencimiento"
                            name="fecha_oblea_matafuegos"
                            size="small"
                            type="date"
                            focused
                            required
                            fullWidth
                            value={moment(
                              datosTanque.fecha_oblea_matafuegos
                            ).format("YYYY-MM-DD")}
                            onChange={almacenar}
                            sx={{ mb: 2 }}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                  {/* Bloque VTV */}
                  <Grid item xs={12} sm={6} md={4.5}>
                    <Box
                      border={1}
                      borderColor="grey.400"
                      backgroundColor="#F4F6F6"
                      borderRadius={2}
                      p={2}
                    >
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        gutterBottom
                      >
                        VTV
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <TextField
                            style={style}
                            label="Vencimiento"
                            name="fecha_vtv"
                            size="small"
                            type="date"
                            sx={{ mb: 2 }}
                            focused
                            required
                            fullWidth
                            value={moment(datosTanque.fecha_vtv).format(
                              "YYYY-MM-DD"
                            )}
                            onChange={almacenar}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          {tipoVTV?.length > 0 && (
                            <FormControl style={style} focused>
                              <InputLabel>Periodicidad</InputLabel>
                              <Select
                                fullWidth
                                label="Periodicidad"
                                required
                                size="small"
                                name="tipo_ven_vtv"
                                value={datosTanque.tipo_ven_vtv || ""}
                                onChange={almacenar}
                                displayEmpty
                              >
                                {" "}
                                <MenuItem value="" disabled>
                                  Seleccionar...
                                </MenuItem>
                                {tipoVTV.map((elemento) => (
                                  <MenuItem
                                    key={elemento.id}
                                    value={elemento.id}
                                  >
                                    {elemento.valor}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                  {/* Bloque Seguro */}
                  <Grid item xs={12} sm={6} md={4.5}>
                    <Box
                      border={1}
                      borderColor="grey.400"
                      backgroundColor="#F4F6F6"
                      borderRadius={2}
                      p={2}
                    >
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        gutterBottom
                      >
                        Seguro
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <TextField
                            style={style}
                            label="Vencimiento"
                            name="fecha_seguro"
                            size="small"
                            type="date"
                            focused
                            required
                            fullWidth
                            value={moment(datosTanque.fecha_seguro).format(
                              "YYYY-MM-DD"
                            )}
                            sx={{ mb: 2 }}
                            onChange={almacenar}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          {tipoSeguro?.length > 0 && (
                            <FormControl style={style} focused>
                              <InputLabel>Periodicidad</InputLabel>
                              <Select
                                fullWidth
                                label="Periodicidad"
                                required
                                size="small"
                                name="tipo_ven_seguro"
                                value={datosTanque.tipo_ven_seguro || ""}
                                onChange={almacenar}
                                displayEmpty
                              >
                                {" "}
                                <MenuItem value="" disabled>
                                  Seleccionar...
                                </MenuItem>
                                {tipoSeguro?.map((elemento) => (
                                  <MenuItem
                                    key={elemento.id}
                                    value={elemento.id}
                                  >
                                    {elemento.valor}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>

          <Stack direction="row">
            <Grid container direction={{ xs: "column", sm: "row" }}>
              <Grid item xs={9} mt={2}>
                <Button variant="contained" color="error" onClick={handleClose}>
                  Volver
                </Button>
              </Grid>
              <Grid item xs={3} mt={2}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={disabledGuardar}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </Stack>
        </form>
      </Container>
      <br></br>
      <br></br>
      {notificacion ? (
        <Notify
          mensaje={mensaje}
          open={openSnack}
          color={colormensaje}
          autoHideDuration={6000}
          finalizar={setFinalizar}
          severity={severitySnack}
        />
      ) : null}
      {/* ALERT --> SE MUESTRA SI HAY UN ERROR EN LA API (NO SE CONECTA O ESTÁ MAL LA RUTA, ETC.) */}
      {error && mensajeAlerta ? (
        <Alerta mensaje={mensajeAlerta} severity={severityAlerta} />
      ) : null}
    </div>
  );
}

export default EditarTanque;
